/**
 * Relay for Header
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const HeaderFragment = graphql`
  fragment header_viewer on Viewer {
    home_page {
      header_posts {
        title
        subtitle
        post_url
        image_url
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/header.ts